// extracted by mini-css-extract-plugin
export default {"image":"login_image__l1hbg","login__wrapper":"login_login__wrapper__iXw13","form__wrapper":"login_form__wrapper__k6K7p","input100":"login_input100__QgtJB"};